// @flow

// Libs
import _size from 'lodash/size'

// Constants
import { GRID_UNIT_ACRES, GRID_UNIT_HECTARES } from 'hfty-model-grid'
import { PROP_US_CUSTOMARY, PROP_METRIC } from 'fc-model-users'

import {
  LB_PER_TON,
  KG_PER_TON,
} from 'hfty'

import {
  PROP_LBS_PER_BU,
  PROP_HEFTY_YIELD_UNIT,
  BUSHELS,
  TONS,
  KGS,
} from 'fc-model-crops'

export default (value: number, from: string, to: string): number => {
  if (from === GRID_UNIT_ACRES && to === GRID_UNIT_HECTARES) {
    return value * 0.404686
  }

  console.warn(`Unit conversion from ${from} to ${to} not supported by this function`)
  return value
}

export function getCropUnit (crop: Object, unitSystem: string): string {
  if (_size(crop) && unitSystem === PROP_US_CUSTOMARY) {
    return crop[PROP_HEFTY_YIELD_UNIT]
  } else if (unitSystem === PROP_METRIC) {
    return KGS
  } else {
    return BUSHELS
  }
}

export function getHeftyCropConversionFactor (crop: Object, unitSystem: string): number {
  const TonPerBuCrop = crop[PROP_LBS_PER_BU] / LB_PER_TON
  const cropUnit = unitSystem === PROP_US_CUSTOMARY ? crop[PROP_HEFTY_YIELD_UNIT] : KGS
  switch (cropUnit) {
    case BUSHELS:
      return 1 / TonPerBuCrop
    case TONS:
      return 1
    case KGS:
      return KG_PER_TON
    default:
      return 1
  }
}
